import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import IconClose from 'components/icons/iconClose';
const MenuButton = t0 => {
  const $ = _c(31);
  const {
    onClick,
    open
  } = t0;
  const t1 = open ? "Close menu" : "Open menu";
  let t2;
  if ($[0] !== open) {
    t2 = classNames("cursor-pointer max-w-[16px] relative w-4 flex flex-col", {
      open
    });
    $[0] = open;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== open) {
    t3 = classNames("bg-gray h-0.5 [transition:all_.2s_ease-in]", {
      "opacity-0 scale-0": open
    });
    $[2] = open;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className={t3} />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== open) {
    t5 = classNames("bg-gray h-0.5 [transition:all_.2s_ease-in] mx-0 my-1", {
      "opacity-0 scale-0": open
    });
    $[6] = open;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <span className={t5} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== open) {
    t7 = classNames("bg-gray h-0.5 [transition:all_.2s_ease-in]", {
      "opacity-0 scale-0": open
    });
    $[10] = open;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <span className={t7} />;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = !open;
  let t10;
  if ($[14] !== open || $[15] !== t9) {
    t10 = classNames("absolute left-0 top-0 [transition:all_.2s_ease-in] ml-0.5 [&_path]:fill-gray", {
      "opacity-0 scale-0": t9,
      "opacity-100 scale-100": open
    });
    $[14] = open;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconClose />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10) {
    t12 = <span className={t10}>{t11}</span>;
    $[18] = t10;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t2 || $[22] !== t4 || $[23] !== t6 || $[24] !== t8) {
    t13 = <span className={t2}>{t4}{t6}{t8}{t12}</span>;
    $[20] = t12;
    $[21] = t2;
    $[22] = t4;
    $[23] = t6;
    $[24] = t8;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== onClick || $[27] !== open || $[28] !== t1 || $[29] !== t13) {
    t14 = <button aria-label={t1} aria-expanded={open} data-xc="menu" className="bg-transparent border-0 flex items-center justify-center h-full w-full focus-visible:rounded-[3px]" onClick={onClick} type="button">{t13}</button>;
    $[26] = onClick;
    $[27] = open;
    $[28] = t1;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};
MenuButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  open: PropTypes.bool
};
export default MenuButton;